import api from './api';

const motifsGarantieApi = {
  getAll: () => api.get('/motifs-garantie'),
  create: (data) => api.post('/motifs-garantie', data),
  update: (id, data) => api.put(`/motifs-garantie/${id}`, data),
  delete: (id) => api.delete(`/motifs-garantie/${id}`)
};

export default motifsGarantieApi;
